<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.set_money_pwd')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="wrapper">
        <div class="item">
            <p class="title">{{$t("setting.money_place")}}</p>
            <van-password-input
                :value="opw"
                :length="4"
                :gutter="10"
                :focused="showKeyboard && activePassword === 'opw'"
                @focus="focusPassword('opw')"
            />
        </div>
        <div class="item">
        <p class="title">{{$t("setting.money_again_place")}}</p>
        <van-password-input
            :value="tpw"
            :length="4"
            :gutter="10"
            :focused="showKeyboard && activePassword === 'tpw'"
            @focus="focusPassword('tpw')"
        />
      </div>
        <van-number-keyboard
            :show="showKeyboard"
            @input="onPasswordInput"
            @delete="onPasswordDelete"
            @blur="showKeyboard = false"
        />
        <van-button class="sub-btn" type="default" :loading="submitting" :disabled="submitting" @click="setPayPassword()">{{$t("reservation.submit")}}</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      opw: '',
      tpw: '',
      activePassword: 'opw',
      showKeyboard: true,
      submitting: false,
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    focusPassword(field) {
      if (this.submitting) return;
      this.activePassword = field;
      this.showKeyboard = true;
    },
    onPasswordInput(value) {
      if (!this.showKeyboard || this.submitting || !/^\d$/.test(String(value))) return;
      const field = this.activePassword;
      if (this[field].length >= 4) return;

      // Apply each key synchronously: Vant's v-model value updates after input,
      // so rapid presses must not depend on a keyboard's last rendered value.
      this[field] += String(value);
      if (this[field].length === 4) {
        if (field === 'opw' && this.tpw.length < 4) {
          this.activePassword = 'tpw';
        } else {
          this.showKeyboard = false;
        }
      }
    },
    onPasswordDelete() {
      if (!this.showKeyboard || this.submitting) return;
      const field = this.activePassword;
      this[field] = this[field].slice(0, -1);
    },
    async setPayPassword() {
      if (this.submitting) return;
      this.showKeyboard = false;
      if (!/^\d{4}$/.test(this.opw)) {
        this.focusPassword('opw');
        this.$toast(this.$t("setting.prefect"));
        return false;
      }
      if (!/^\d{4}$/.test(this.tpw)) {
        this.focusPassword('tpw');
        this.$toast(this.$t("setting.prefect"));
        return false;
      }
      if(this.opw !== this.tpw){
        this.focusPassword('tpw');
        this.$toast(this.$t("setting.pwd_error"));
        return false;
      }
      this.submitting = true;
      try {
        const res = await this.$http({
          method: 'post',
          data:{paypassword:this.opw},
          url: 'user_set_paypw'
        });
        if(res.code === 200){
            setTimeout(() => {
              this.$toast(res.msg);
            }, 500);
          this.$router.push("Mine");
        } else {
          this.$toast(res.msg || this.$t('common.request_failed'));
        }
      } catch (error) {
        this.$toast(this.$t('common.network_error'));
      } finally {
        this.submitting = false;
      }
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.radio = res.data.sex;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.container .wrapper{
  height: 100%;
  //overflow-y: auto;
  background-color: #fff;
  //-webkit-overflow-scrolling: touch;
}
.container .wrapper .item .title{
  margin: 40px 0;
  line-height: 20px;
  font-size: 32.4px;
  font-weight: 700;
  color: #000;
  text-align: center;
}
::v-deep .van-password-input{
  width: 80%;
  height: 150px;
  margin: 0 auto;

}
::v-deep .van-password-input__security li {
  font-size: 32.4px;
  line-height: 30;
  background-color: #ebedf0;
}
::v-deep .van-password-input__security {
  height: 130px;
}
::v-deep .van-password-input .van-password-input__security .van-password-input__item {
  height: 100%;
  border: 0;
  text-align: center;
  border-radius: 30px;
}
.van-password-input__security i {
  width: 25px;
  height: 25px;
}
::v-deep .van-key {
  height: 100px;
  font-size: 59.4px;
  line-height: 20px;
  border-radius: 20px;
}
::v-deep .van-number-keyboard {
  z-index:100;
  width: 100%;
  padding-bottom: 30px;
  background-color: #f2f3f5;
}
::v-deep .van-key__collapse-icon {
   width: 50px;
   height: 50px;
 }
::v-deep .van-key__delete-icon {
  width: 50px;
  height: 50px;
}
.container .wrapper .sub-btn{
  margin: 110px 0 0 10%;
  height: 100px;
  width: 80%;
  font-size: 37.8px;
  border-radius: 50px;
  color: #fff;
  background: linear-gradient(
      270deg,#e6c3a1,#7e5678);
}
</style>
